import { Box, Grid } from '@mui/material';
import useResponsibleForm, { IResponsibleForm } from '../../hooks/useResponsibleForm';
import CustomField from '../../../../../../components/CustomFormsComponents/CustomField';
import ButtonActions from '../../../../../../components/ButtonActions';
import { DrawerHeader } from '../../../../../../components/Drawer/DrawerHeader';
import BackdropComponent from '../../../../../../components/Backdrop/BackdropComponent';

const ResponsibleForm = ({ handleCloseDrawer, selected, isEditing, onlyVisual }: any) => {
    const responsibleForm = useResponsibleForm({
        selectedResponsible: selected,
        isEditing: isEditing,
        handleCloseDrawer: handleCloseDrawer
    });
    const {
        formData,
        responsibleFieldsConfig,
        errors,
        isAddingResponsible,
        isEditingResponsible,
        handleChange,
        translate,
        handleSubmit
    } = responsibleForm;

    return (
        <Box
            display="flex"
            flexDirection={'column'}
            justifyContent="space-between"
            sx={{ flexDirection: 'column', height: '100%', minHeight: '100%' }}
        >
            <Grid p={1}>
                <DrawerHeader
                    onIconClick={handleCloseDrawer}
                    text={translate(
                        `responsiblesAndContractorsForms.newResponsible.titles.${
                            isEditing ? 'edit' : 'new'
                        }`
                    )}
                />
                <Grid mt={2} container spacing={2} rowSpacing={0.01}>
                    {responsibleFieldsConfig.map((field, index) => (
                        <Grid
                            item
                            xs={field?.gridSpace?.xs}
                            sm={field?.gridSpace?.sm}
                            md={field?.gridSpace?.md}
                            lg={field?.gridSpace?.lg}
                            key={index}
                        >
                            <CustomField
                                config={field}
                                value={formData[field.name as keyof IResponsibleForm]}
                                onChange={handleChange}
                                onlyVisual={onlyVisual}
                                error={errors[field.name as string]?.hasError}
                                helperText={
                                    errors[field.name as string]?.errorMessage || field.helperText
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ marginTop: '1rem' }}
            >
                <Box
                    sx={{
                        '& > :not(style)': { m: 1 },
                        display: 'flex'
                    }}
                >
                    {!onlyVisual && (
                        <ButtonActions
                            handleClose={handleCloseDrawer}
                            renderBackAction
                            returnText={translate('responsiblesAndContractorsForms.buttons.cancel')}
                            confirmText={translate('responsiblesAndContractorsForms.buttons.save')}
                            loading={false}
                            disabled={false}
                            onClick={handleSubmit}
                            borderRadius="4px"
                            size="small"
                        />
                    )}
                </Box>
            </Grid>
            <BackdropComponent loading={isAddingResponsible || isEditingResponsible} />
        </Box>
    );
};


export { ResponsibleForm };